/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetUsersRecruiters200, GetUsersRecruiters400, GetUsersRecruitersQueryResponse } from '../entities/GetUsersRecruiters'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1GetRecruitersResponseSchema } from './v1/getRecruitersResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const getUsersRecruiters200Schema = z.lazy(() => v1GetRecruitersResponseSchema) as unknown as ToZod<GetUsersRecruiters200>

/**
 * @description Bad Request
 */
export const getUsersRecruiters400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetUsersRecruiters400>

export const getUsersRecruitersQueryResponseSchema = z.lazy(() => getUsersRecruiters200Schema) as unknown as ToZod<GetUsersRecruitersQueryResponse>